import React from "react";
import Lookup from "../../Components/Attributes/AttributeTemplate/Lookup";
import OrganisationPlanning from "../../Components/Planning/OrganisationPlanning";

const WorkspaceOrganizationPlanningPage = ({ organization, user, role }) => {
    return (
        <OrganisationPlanning
            user={user}
            userRole={role.roleType}
            organization={organization}
        />

    );
};

export default WorkspaceOrganizationPlanningPage; 